import { Helmet } from "react-helmet-async";
import { useSettings } from "@/contexts/SettingsContext";

const DEFAULT_LOGO_URL = "/api/files/creativecodez/uploads/ca6e44b1-8c67-4695-9967-b582c762baca.png";

export const OrganizationSchema = () => {
  const settings = useSettings();
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: settings.brand_name || "Creative Codez",
    url: origin,
    logo: `${origin}${settings.logo_url || DEFAULT_LOGO_URL}`,
    email: settings.brand_email,
    description:
      "Creative Codez is a web & app development and digital marketing agency specializing in Website Development, Application Development, SEO, AEO, GEO, Local SEO, Content Marketing and Performance Marketing.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "3773 Carmel View Rd #3",
      addressLocality: "San Diego",
      addressRegion: "CA",
      postalCode: "92130",
      addressCountry: "US",
    },
    sameAs: [],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
